import { DestroyRef, Signal, effect } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  DeploySystemCorrectionObservedField,
  DeploySystemCorrectionObservedFieldStatus,
} from '@/app/interfaces/deploy-system-correction';

export function setupObservedFieldsTracking(
  form: FormGroup,
  observedFields: Signal<DeploySystemCorrectionObservedField[]>,
  destroyRef: DestroyRef,
  onStatusChange: (status: DeploySystemCorrectionObservedFieldStatus) => void
): void {
  const trackedFields = new Set<DeploySystemCorrectionObservedField>();

  effect(() => {
    observedFields().forEach((field) => {
      if (trackedFields.has(field)) {
        return;
      }

      const control = form.get(field);
      if (!control) {
        return;
      }

      trackedFields.add(field);
      control.addValidators(Validators.required);
      control.updateValueAndValidity({ emitEvent: false });

      control.valueChanges.pipe(takeUntilDestroyed(destroyRef)).subscribe(() => {
        control.addValidators(Validators.required);
        control.updateValueAndValidity({ emitEvent: false });
        onStatusChange({ field, valid: control.valid });
      });
    });
  });
}
